<section class="winners-modal" role="document">
  <button
    type="button"
    class="winners-modal__close"
    [attr.aria-label]="'promotions.detail.winnersModal.close' | translate"
    (click)="close()"
  >
    <img src="assets/img/promotions/detail/modal-close-linear.svg" alt="" aria-hidden="true" />
  </button>

  <header class="winners-modal__header">
    <h2>{{ 'promotions.detail.winnersModal.title' | translate }}</h2>
  </header>

  <div class="winners-modal__body">
    <h3>{{ modalData.promotionName }}</h3>
    <div class="winners-modal__status">
      <span>{{ 'promotions.detail.winnersModal.status' | translate }}</span>
      <strong>{{ 'promotions.detail.statusTags.ended' | translate }}</strong>
    </div>

    <div
      class="winners-modal__table"
      role="table"
      [attr.aria-label]="'promotions.detail.winnersModal.title' | translate"
    >
      <div class="winners-modal__head" role="row">
        <span role="columnheader">{{ 'promotions.detail.winnersModal.place' | translate }}</span>
        <span role="columnheader">{{ 'promotions.detail.winnersModal.name' | translate }}</span>
        <span role="columnheader">{{ 'promotions.detail.winnersModal.reward' | translate }}</span>
      </div>
      @for (winner of winnerRows(); track winner.id) {
        <div class="winners-modal__row" role="row">
          <span role="cell">{{ winner.place }}</span>
          <span role="cell">{{ winner.name }}</span>
          <span role="cell">{{ winner.reward }}</span>
        </div>
      }
      @if (totalPages() > 1) {
        <div
          class="winners-modal__pagination"
          [attr.aria-label]="'promotions.detail.winnersModal.pagination' | translate"
        >
          <button
            type="button"
            class="winners-modal__chevron"
            [disabled]="currentPage() === 1"
            [attr.aria-label]="'promotions.detail.winnersModal.previousPage' | translate"
            (click)="onPageChange(currentPage() - 1)"
          >
            ‹
          </button>
          @for (page of pageNumbers(); track page) {
            <button
              type="button"
              [class.winners-modal__page--active]="page === currentPage()"
              [attr.aria-current]="page === currentPage() ? 'page' : null"
              (click)="onPageChange(page)"
            >
              {{ page }}
            </button>
          }
          <button
            type="button"
            class="winners-modal__chevron"
            [disabled]="currentPage() === totalPages()"
            [attr.aria-label]="'promotions.detail.winnersModal.nextPage' | translate"
            (click)="onPageChange(currentPage() + 1)"
          >
            ›
          </button>
        </div>
      }
    </div>
  </div>
</section>
